export default __webpack_public_path__ + "static/media/white-cross.576961d2.svg";